import { QUESTION_TYPE, UPLOAD_DOCUMENT } from "../shared/constants/assessment-flow"
import { useAssessmentStore } from "../shared/store"

const ProgressBar = () => {
    const { currentStep, totalQuestions } = useAssessmentStore((state) => ({
        currentStep: state.currentStep,
        totalQuestions: state.assesmentQuestions.questions.length,
    }))
    return (
        <div className="flex flex-col gap-2">
            {/* <div className="flex justify-center text-sm font-semibold text-primary">
                {UPLOAD_DOCUMENT[docType.docType]}
            </div> */}
            <div className="">
                <div className="flex w-full bg-gray-200 rounded-full h-1 items-center">
                    <div
                        style={{
                            width: `${((currentStep + 1) / totalQuestions) * 100}%`,
                        }}
                        className={`bg-green h-1.5 rounded-full`}
                    ></div>
                </div>
            </div>
        </div>
    )
}

export const NumberOfQuestions = () => {
    const { currentStep, totalQuestions } = useAssessmentStore((state) => ({
        currentStep: state.currentStep,
        totalQuestions: state.assesmentQuestions.questions.length,
    }))

    return (
        <div className="flex justify-center text-onSurface-secondary text-xs">
            Question {`${currentStep + 1} / ${totalQuestions}`}
        </div>
    )
}

export const ProgressHeading = () => {
    const { currentStep, assesmentQuestions } = useAssessmentStore((state) => state)
    const questionType = assesmentQuestions?.questions[currentStep]?.question_type
    let type = ""
    if (questionType === QUESTION_TYPE.AUDIO_UPLOAD)
        type = assesmentQuestions?.questions[currentStep]?.question_type
    else if (questionType === QUESTION_TYPE.UPLOAD)
        type = type = assesmentQuestions?.questions[currentStep]?.question_type
    else if (questionType === QUESTION_TYPE.RESUME_UPLOAD)
        type = assesmentQuestions?.questions[currentStep]?.question_type
    else if (questionType === QUESTION_TYPE.JOB_PREFERENCE)
        type = assesmentQuestions?.questions[currentStep]?.question_type
    else if (questionType === QUESTION_TYPE.ASSET)
        type = assesmentQuestions?.questions[currentStep]?.question_type

    return (
        <h3 className="flex justify-center text-sm font-semibold text-primary">
            {UPLOAD_DOCUMENT[type]}
        </h3>
    )
}

export const Progress = () => {
    return (
        <div className="flex flex-col gap-2 pt-8 w-full">
            <ProgressHeading />
            <ProgressBar />
            <NumberOfQuestions />
        </div>
    )
}

export default Progress
